import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



import { MatDividerModule } from '@angular/material/divider';

import { ToggleModule } from 'src/app/shared/components/toggle/toggle.module';
import { CompareProductsModule } from 'src/app/shared/components/compare-products/compare-products.module';
import { PackageModule } from '../..//shared/components/package/package.module';
import { ProductModule } from "../../shared/components/product/product.module";

import { CatalogService } from '../../shared/services/catalog.service';

import { CheckoutMyPlanComponent } from './my-plan.component';
import { MatIconModule } from "@angular/material/icon";
import { SdsnShopWindowModule } from '../shop-windows/sdsn-shop-window/sdsn-shop-window.module';
import { AssinaturaShopWindowModule } from "../shop-windows/assinatura-shop-window/assinatura-shop-window.module";
import { DescomplicaShopWindowModule } from "../shop-windows/descomplica-shop-window/descomplica-shop-window.module";
import { MonitoreShopWindowModule } from '../shop-windows/monitore-shop-window/monitore-shop-window.module';
import { ConsultaShopWindowModule } from "../shop-windows/consulta-shop-window/consulta-shop-window.module";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  imports: [
    CommonModule,
    ToggleModule,
    CompareProductsModule,
    SdsnShopWindowModule,
    
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    PackageModule,
    ProductModule,
    MatIconModule,
    AssinaturaShopWindowModule,
    DescomplicaShopWindowModule,
    MonitoreShopWindowModule,
    ConsultaShopWindowModule
],
  exports: [
    CheckoutMyPlanComponent
  ],
  providers: [
    CatalogService
  ],
  declarations: [
    CheckoutMyPlanComponent
  ]
})
export class CheckoutMyPlanModule { }
